
import { atom } from "recoil"

export const AtomCurrentProfileAvailable = atom({
    key:'ATOMCURRENTPROFILEAVAILABLE',
    default:[]
})